<!-- TheFooter.vue -->
<script setup lang="ts">

import { useI18n } from "vue-i18n";
import jaJP from "@/locales/ja-JP.json";
import enUS from "@/locales/en-US.json";

type MessageSchema = typeof jaJP;

const { t } = useI18n<{
  message: MessageSchema
}, "ja-JP" | "en-US">({
  inheritLocale: true,
  messages: {
    "ja-JP": jaJP,
    "en-US": enUS,
  }
});

</script>

<template>
  <footer>
    <p class="copy">
      <small>&copy; 2022 {{ t("app.title") }}</small>
    </p>
    <p class="info">
      <small>&copy; SEGA PHANTASY STAR ONLINE 2 (jp: <a href="https://pso2.jp/" target="_blank">https://pso2.jp/</a>, gl: <a href="https://pso2.com/" target="_blank">https://pso2.com/</a>).</small><br>
      <small>{{ t("footer.copies.sega") }}</small><br>
      <small>{{ t("footer.copies.other") }}</small>
    </p>
  </footer>
</template>

<style scoped lang="scss">
@import "@/assets/sass/mixin.scss";

footer {
  @include dark-bordered-text();
  padding: .5rem;
  background-color: rgba(7, 15, 30, .8);
  color: #fffeec;
}

p {
  margin: 0 auto;
  padding-bottom: 0.5rem;
  text-align: center;
}
.info {
  font-size: .9rem;
  a {
    color: #fffeec;
  }
}

</style>
